import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { registerEmploymentBasicStep as registerLocales } from 'globals/locales/registration';
import FsRegisterEmploymentBasicsForm from 'ui-elements/forms/FsRegisterEmploymentBasicsForm';
import { FsRegisterEmploymentBasicsFormDataProps } from 'ui-elements/forms/FsRegisterEmploymentBasicsForm/FsRegisterEmploymentBasicsForm';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterEmploymentBasicsStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface OnGoNextProps {
  showTransactionDetails: boolean;
}

interface RegisterEmploymentBasicsStepProps extends RegisterStepProps {
  onGoNext?: (props?: OnGoNextProps) => void;
}

const RegisterEmploymentBasicsStep: React.FC<RegisterEmploymentBasicsStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  const [formDefaults] = useState<FsRegisterEmploymentBasicsFormDataProps>({
    showTransactionDetails: '',
  });

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <Box maxWidth={400}>
        <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
        <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
        <FsCenterBoxLine />
      </Box>
      <Box marginTop={3}>
        <FsRegisterEmploymentBasicsForm {...formDefaults} onGoNext={onGoNext} />
      </Box>
    </WrapperBox>
  );
};

export default RegisterEmploymentBasicsStep;
